"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Alert = _interopRequireWildcard(require("../Alert/Alert"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Notification = exports.Notification = function Notification(_ref) {
  var children = _ref.children,
    type = _ref.type,
    text = _ref.text,
    transitionState = _ref.transitionState,
    onDismiss = _ref.onDismiss,
    transitionDuration = _ref.transitionDuration;
  return /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    style: {
      transitionDuration: "".concat(transitionDuration, "ms")
    },
    text: text,
    className: "margin-bottom-md ".concat(transitionState),
    type: type,
    onClose: onDismiss,
    disableTransition: true
  }, children && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-between "
  }, (0, _Alert.AlertIcon)(type), /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-x-sm"
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert-close-button-container"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    buttonSize: _constants.BUTTON_SIZES.LARGE,
    buttonType: _constants.BUTTON_TYPES.BARE_WHITE_NO_PADDING,
    icon: "cross",
    onClick: onDismiss
  })))));
};
Notification.propTypes = {
  children: _propTypes["default"].any,
  type: _propTypes["default"].string,
  text: _propTypes["default"].string,
  transitionState: _propTypes["default"].string,
  onDismiss: _propTypes["default"].func,
  transitionDuration: _propTypes["default"].number
};